import React from 'react';
import './SevenDays.min.css'
import Click from './Click'
const SevenDays = props => {
    const {err, city, sunrise, sunset, tempMin, tempMax, pressure, wind, icon, humidity, id, 
        date2,  sunrise2, sunset2, tempMin2, tempMax2, pressure2, wind2, icon2, humidity2, id2,
        date3,  sunrise3, sunset3, tempMin3, tempMax3, pressure3, wind3, icon3, humidity3, id3,
        date4,  sunrise4, sunset4, tempMin4, tempMax4, pressure4, wind4, icon4, humidity4, id4,
        date5,  sunrise5, sunset5, tempMin5, tempMax5, pressure5, wind5, icon5, humidity5, id5,
        date6,  sunrise6, sunset6, tempMin6, tempMax6, pressure6, wind6, icon6, humidity6, id6,
        date7,  sunrise7, sunset7, tempMin7, tempMax7, pressure7, wind7, icon7, humidity7, id7,
    } = props.weather


    let content = null;
    let numberId = Number(Object.values({id}));
    let numberId2 = Number(Object.values({id2}));
    let numberId3 = Number(Object.values({id3}));
    let numberId4 = Number(Object.values({id4}));
    let numberId5 = Number(Object.values({id5}));
    let numberId6 = Number(Object.values({id6}));
    let numberId7 = Number(Object.values({id7}));

    let niebo = {
        200:"Burza z piorunami z lekkim deszczem",
        201:"Burza z piorunami z deszczem",
        202:"Burza z piorunami z ulewnym deszczem",
        210:"Lekka burza z piorunami",
        211:"Burza z piorunami",
        212:"Silna burza z piorunami",
        221:"Burza z piorunami",
        230:"Burza z piorunami z lekką mżawką",
        231:"Burza z piorunami z mżawką",
        232:"Burza z piorunami z ulewną mżawką",
        300:"Lekka mżawka",
        301:"Mżawka",
        302:"Intensywna mżawka",
        310:"Lekki deszcz",
        311:"Deszcz",
        312:"Ulewa",
        313:"Mżawka lub deszcz",
        314:"Intensywna mżawka lub deszcz",
        321:"Deszczowa mżawka",
        500:"Lekki deszcz",
        501:"Umiarkowane opady deszczu",
        502:"Intensywny deszcz",
        503:"Bardzo ulewny deszcz",
        504:"Ekstremalny deszcz",
        511:"Marznący deszcz",
        520:"Lekki deszcz",
        521:"Umiarkowane opady",
        522:"Bardzo ulewny deszcz",
        531:"Deszcz",
        600:"Lekkie opady śniegu",
        601:"Śnieg",
        602:"Duże opady śniegu",
        611:"Śnieg z deszczem",
        612:"Lekki deszcz ze śniegiem",
        613:"Deszcz ze śniegiem",
        615:"Lekki deszcz ze śniegiem",
        616:"Deszcz i śnieg",
        620:"Lekki opady deszczu ze śniegiem",
        621:"Śnieg",
        622:"Duże opady śniegu",
        701:"Mgła",
        711:"Smog",
        721:"Mgła",
        731:"Zamiecie",
        741:"Mgła",
        751:"Burza piaskowa",
        761:"Pył",
        762:"Pył wulkaniczny",
        771:"Szkwał",
        781:"Tornado",
        800:"Czyste niebo",
        801:"Zachmurzenie: 11-25%",
        802:"Zachmurzenie: 25-50%",
        803:"Zachmurzenie: 51-84%",
        804:"Zachmurzenie: 85-100%",
    }
    let descripitonWeather = niebo[numberId];
    let descripitonWeather2 = niebo[numberId2];
    let descripitonWeather3 = niebo[numberId3];
    let descripitonWeather4 = niebo[numberId4];
    let descripitonWeather5 = niebo[numberId5];
    let descripitonWeather6 = niebo[numberId6];
    let descripitonWeather7 = niebo[numberId7];

    if(!err && city){
        let sunriseTime1 = new Date(sunrise * 1000).toLocaleTimeString();
        let sunsetTime1 = new Date(sunset * 1000).toLocaleTimeString();
        let sunriseTime1a = new Date(sunrise*1000);
        let sunsetTime1a = new Date(sunset*1000);
        let differentTime1 = new Date(sunsetTime1a.getTime() - sunriseTime1a.getTime());
        let lenghtDay1 = ((differentTime1.getHours()) - 1 + ":" + differentTime1.getMinutes() + ":" + differentTime1.getSeconds());

        let sunriseTime2 = new Date(sunrise2 * 1000).toLocaleTimeString();
        let sunsetTime2 = new Date(sunset2 * 1000).toLocaleTimeString();
        let sunriseTime2a = new Date(sunrise2*1000);
        let sunsetTime2a = new Date(sunset2*1000);
        let differentTime2 = new Date(sunsetTime2a.getTime() - sunriseTime2a.getTime());
        let lenghtDay2 = ((differentTime2.getHours()) - 1 + ":" + differentTime2.getMinutes() + ":" + differentTime2.getSeconds());
        
        let sunriseTime3 = new Date(sunrise3 * 1000).toLocaleTimeString();
        let sunsetTime3 = new Date(sunset3 * 1000).toLocaleTimeString();
        let sunriseTime3a = new Date(sunrise3*1000);
        let sunsetTime3a = new Date(sunset3*1000);
        let differentTime3 = new Date(sunsetTime3a.getTime() - sunriseTime3a.getTime());
        let lenghtDay3 = ((differentTime3.getHours()) - 1 + ":" + differentTime3.getMinutes() + ":" + differentTime3.getSeconds());

        let sunriseTime4 = new Date(sunrise4 * 1000).toLocaleTimeString();
        let sunsetTime4 = new Date(sunset4 * 1000).toLocaleTimeString();
        let sunriseTime4a = new Date(sunrise4*1000);
        let sunsetTime4a = new Date(sunset4*1000);
        let differentTime4 = new Date(sunsetTime4a.getTime() - sunriseTime4a.getTime());
        let lenghtDay4 = ((differentTime4.getHours()) - 1 + ":" + differentTime4.getMinutes() + ":" + differentTime4.getSeconds());

        let sunriseTime5 = new Date(sunrise5 * 1000).toLocaleTimeString();
        let sunsetTime5 = new Date(sunset5 * 1000).toLocaleTimeString();
        let sunriseTime5a = new Date(sunrise5*1000);
        let sunsetTime5a = new Date(sunset5*1000);
        let differentTime5 = new Date(sunsetTime5a.getTime() - sunriseTime5a.getTime());
        let lenghtDay5 = ((differentTime5.getHours()) - 1 + ":" + differentTime5.getMinutes() + ":" + differentTime5.getSeconds());
        
        let sunriseTime6 = new Date(sunrise6 * 1000).toLocaleTimeString();
        let sunsetTime6 = new Date(sunset6 * 1000).toLocaleTimeString();
        let sunriseTime6a = new Date(sunrise6*1000);
        let sunsetTime6a = new Date(sunset6*1000);
        let differentTime6 = new Date(sunsetTime6a.getTime() - sunriseTime6a.getTime());
        let lenghtDay6 = ((differentTime6.getHours()) - 1 + ":" + differentTime6.getMinutes() + ":" + differentTime6.getSeconds());
      
        let sunriseTime7 = new Date(sunrise7 * 1000).toLocaleTimeString();
        let sunsetTime7 = new Date(sunset7 * 1000).toLocaleTimeString();
        let sunriseTime7a = new Date(sunrise7*1000);
        let sunsetTime7a = new Date(sunset7*1000);
        let differentTime7 = new Date(sunsetTime7a.getTime() - sunriseTime7a.getTime());
        let lenghtDay7 = ((differentTime7.getHours()) - 1 + ":" + differentTime7.getMinutes() + ":" + differentTime7.getSeconds());

        content = (
            
            <div onLoad={props.function}  class="weather">
                
                    <nav id='one' className='one'>
                    <p class='date'>Dzisiaj</p>
                    <p class='descriptionWeather'>{descripitonWeather}</p>
                    <p class='tempDay'> {Math.round (tempMax)}&#176;C  &#8593; &#9900; {Math.round (tempMin)}&#176;C &#8595; <span>  <i class="fa-solid fa-angle-down"></i></span></p>
                    <img src= {"icon_id/" + icon + ".png"} id='icon'></img>
                    </nav>
                
                <div id='more' class="notMore">
                    <p>Wiatr: {wind} km/h </p>
                    <p>Ciśnienie: {pressure} hPa </p>
                    <p>Wilgotność: {humidity} %</p>
                    <p><span>Wschód słonca: {sunriseTime1}</span>   </p>
                    <p><span>Zachód słonca: {sunsetTime1}</span> </p>
                    <p>Długość dnia: {lenghtDay1} </p>
                </div>
                                
                <nav id='two' className='one'>
                    <p class='date'>{date2}</p>
                    <p class='descriptionWeather'>{descripitonWeather2}</p>
                    <p class='tempDay'> {Math.round (tempMax2)}&#176;C  &#8593; &#9900; {Math.round (tempMin2)}&#176;C &#8595; <span>  <i class="fa-solid fa-angle-down"></i></span></p>
                    <img src= {"icon_id/" + icon2 + ".png"} ></img>
                </nav>
                
                <div id='more2' class="notMore">
                    <p>Wiatr: {wind2} km/h </p>
                    <p>Ciśnienie: {pressure2} hPa </p>
                    <p>Wilgotność: {humidity2} %</p>
                    <p><span>Wschód słonca: {sunriseTime2}</span>   </p>
                    <p><span>Zachód słonca: {sunsetTime2}</span> </p>
                    <p>Długość dnia: {lenghtDay2} </p>
                </div>
                
                <nav id='three'  className='one'>
                    <p class='date'>{date3}</p>
                    <p class='descriptionWeather'>{descripitonWeather3}</p>
                    <p class='tempDay'> {Math.round (tempMax3)}&#176;C  &#8593; &#9900; {Math.round (tempMin3)}&#176;C &#8595; <span>  <i class="fa-solid fa-angle-down"></i></span></p>
                    <img src= {"icon_id/" + icon3 + ".png"} ></img>
                </nav>
                
                <div id='more3'  class="notMore">
                    <p>Wiatr: {wind3} km/h </p>
                    <p>Ciśnienie: {pressure3} hPa </p>
                    <p>Wilgotność: {humidity3} %</p>
                    <p><span>Wschód słonca: {sunriseTime3}</span>   </p>
                    <p><span>Zachód słonca: {sunsetTime3}</span> </p>
                    <p>Długość dnia: {lenghtDay3} </p>
                </div>
                <nav id='four'  className='one'>
                    <p class='date'>{date4}</p>
                    <p class='descriptionWeather'>{descripitonWeather4}</p>
                    <p class='tempDay'> {Math.round (tempMax4)}&#176;C  &#8593; &#9900; {Math.round (tempMin4)}&#176;C &#8595; <span>  <i class="fa-solid fa-angle-down"></i></span></p>
                    <img src= {"icon_id/" + icon4 + ".png"} ></img>
                </nav>
                
                <div id='more4'  class="notMore">
                    <p>Wiatr: {wind4} km/h </p>
                    <p>Ciśnienie: {pressure4} hPa </p>
                    <p>Wilgotność: {humidity4} %</p>
                    <p><span>Wschód słonca: {sunriseTime4}</span>   </p>
                    <p><span>Zachód słonca: {sunsetTime4}</span> </p>
                    <p>Długość dnia: {lenghtDay4} </p>
                </div>
                <nav id='five'  className='one'>
                    <p class='date'>{date5}</p>
                    <p class='descriptionWeather'>{descripitonWeather5}</p>
                    <p class='tempDay'> {Math.round (tempMax5)}&#176;C  &#8593; &#9900; {Math.round (tempMin5)}&#176;C &#8595; <span>  <i class="fa-solid fa-angle-down"></i></span></p>
                    <img src= {"icon_id/" + icon5 + ".png"} ></img>
                </nav>
                
                <div id='more5'  class="notMore">
                    <p>Wiatr: {wind5} km/h </p>
                    <p>Ciśnienie: {pressure5} hPa </p>
                    <p>Wilgotność: {humidity5} %</p>
                    <p><span>Wschód słonca: {sunriseTime5}</span>   </p>
                    <p><span>Zachód słonca: {sunsetTime5}</span> </p>
                    <p>Długość dnia: {lenghtDay5} </p>
                </div>
                <nav id='six'  className='one'>
                    <p class='date'>{date6}</p>
                    <p class='descriptionWeather'>{descripitonWeather6}</p>
                    <p class='tempDay'> {Math.round (tempMax6)}&#176;C  &#8593; &#9900; {Math.round (tempMin6)}&#176;C &#8595; <span>  <i class="fa-solid fa-angle-down"></i></span></p>
                    <img src= {"icon_id/" + icon6 + ".png"} ></img>
                </nav>
                
                <div id='more6'  class="notMore">
                    <p>Wiatr: {wind6} km/h </p>
                    <p>Ciśnienie: {pressure6} hPa </p>
                    <p>Wilgotność: {humidity6} %</p>
                    <p><span>Wschód słonca: {sunriseTime6}</span>   </p>
                    <p><span>Zachód słonca: {sunsetTime6}</span> </p>
                    <p>Długość dnia: {lenghtDay6} </p>
                </div>
                <nav id='seven'  className='one'>
                    <p class='date'>{date7}</p>
                    <p class='descriptionWeather'>{descripitonWeather7}</p>
                    <p class='tempDay'> {Math.round (tempMax7)}&#176;C  &#8593; &#9900; {Math.round (tempMin7)}&#176;C &#8595; <span>  <i class="fa-solid fa-angle-down"></i></span></p>
                    <img src= {"icon_id/" + icon7 + ".png"} ></img>
                </nav>
                
                <div id='more7'  class="notMore">
                    <p>Wiatr: {wind7} km/h </p>
                    <p>Ciśnienie: {pressure7} hPa </p>
                    <p>Wilgotność: {humidity7} %</p>
                    <p><span>Wschód słonca: {sunriseTime7}</span>   </p>
                    <p><span>Zachód słonca: {sunsetTime7}</span> </p>
                    <p>Długość dnia: {lenghtDay7} </p>
                </div>
              <Click/>
            </div>
            )
    }

    return(
        <div className='sevenDays' id='sevenDays' >
            {err ? `Nie mamy w bazie ${city}` : content}
        
        </div>
    )
}

export default SevenDays;